import * as enums from '@enums';

export function isProjectActive(state: Pick<Store.State, 'projects'>) {
  return (data: IProjectId) => {
    const project = state.projects[data.projectId];

    return project.projectStatusId !== enums.ProjectStatus.Archived;
  };
}